export *                           from './device-mobilephone.class';

export *                           from './device-mobilephone-info.component';

// Special case to allow common-defined class to be accessible thoughout web app
// but only actually imported in one place, here
export { DeviceMobilePhoneCommon } from '@Common/Elements/Devices/';